import React, { useState, useRef, useEffect } from 'react';

export default function VerifyCode({ length, onCodeChange }) {
    const [values, setValues] = useState(new Array(length).fill(''));
    const inputRefs = useRef(Array.from({ length }, () => React.createRef()));

    const handleKeyPress = (event, index) => {
        const inputLength = event.target.value.length;
        const maxLength = parseInt(event.target.maxLength, 6);

        if (event.key === 'Backspace' && index > 0) {
            // If backspacing and the input is empty, focus on the previous input
            if (inputLength === 0) {
                inputRefs.current[index - 1].current.focus();
            } else {
                // Clear the current input
                setValues((prevValues) => {
                    const newValues = [...prevValues];
                    newValues[index] = '';
                    return newValues;
                });
            }
        } else if (inputLength === maxLength && index < length - 1) {
            // Move focus to the next input
            inputRefs.current[index + 1].current.focus();
        }
    };

    const handleChange = (event, index) => {

        const { value } = event.target;

        setValues((prevValues) => {
            const newValues = [...prevValues];
            newValues[index] = value;
            return newValues;
        });

        // Move focus to the next input if the current input is filled
        const inputLength = value.length;
        const maxLength = parseInt(event.target.maxLength, 6);

        if (inputLength === maxLength && index < length - 1) {
            inputRefs.current[index + 1].current.focus();
        }
    };

    // Notify the parent component about the code change
    useEffect(() => {
        onCodeChange(values.join(''));
    }, [onCodeChange, values]);

    return (
        <div className="auth-input-wrapper d-flex align-items-center justify-content-sm-between numeral-mask-wrapper validation-div-center">
            {Array.from({ length }, (_, index) => (
                <input
                    key={index}
                    type="text"
                    className="form-control auth-input h-px-50 text-center numeral-mask text-center h-px-50 mx-1 my-2"
                    maxLength="1"
                    value={values[index]}
                    onChange={(event) => handleChange(event, index)}
                    onKeyDown={(event) => handleKeyPress(event, index)}
                    ref={inputRefs.current[index]}
                />
            ))}
        </div>
    );
}
